import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "./api";

export function useApi(path, params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(Boolean(path));
  const [error, setError] = useState(null);
  const key = path ? `${path}?${JSON.stringify(params || {})}` : "";

  const load = useCallback(async () => {
    if (!path) return;
    setLoading(true);
    try {
      const r = await api.get(path, { params });
      setData(r.data);
      setError(null);
    } catch (e) {
      setError(errMsg(e));
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => { load(); }, [load]);
  return { data, loading, error, reload: load, setData };
}
